/**
 * Configuración de Vercel Web Analytics para el componente <Analytics/> (ADR-170).
 *
 * Dos capas de gating:
 *  1. Entorno (`mode`): solo se envía tráfico real cuando VERCEL_ENV === 'production'.
 *     En preview/dev el modo 'development' desactiva el envío de eventos.
 *  2. Público/privado (`beforeSend`): se descartan las vistas del área privada
 *     (rutas con `meta.requiresAuth`) por compliance GDPR — el área autenticada
 *     (dashboard, casos, perfil, admin, GDPR) NO debe medirse.
 *
 * Analítica cookieless (sin consentimiento) y solo pageviews (sin custom events).
 */

import router from '@/router'

export function useVercelAnalytics() {
  const mode =
    import.meta.env.VITE_VERCEL_ENV === 'production' ? 'production' : 'development'

  /**
   * Filtra cada evento antes de enviarlo. Fail-safe: ante cualquier error o si la
   * ruta resuelta pertenece al área privada, devuelve null (no se envía nada).
   *
   * @param {{ url: string }} event
   * @returns {object|null} el evento si es medible, o null para descartarlo
   */
  function beforeSend(event) {
    try {
      const { pathname } = new URL(event.url)
      const resolved = router.resolve(pathname)
      if (resolved.meta?.requiresAuth) return null
      return event
    } catch {
      return null
    }
  }

  return { mode, beforeSend }
}
